import * as React from "react"
import type { SVGProps } from "react"
const SvgAbTesting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.29q-1.27 0-1.81-1.14a1.85 1.85 0 0 1 .26-2.11L9 11.29v-6H8a1 1 0 0 1-.71-.3A1 1 0 0 1 7 4.3q0-.44.29-.72A1 1 0 0 1 8 3.3h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3h-1v6l5.55 6.75q.8.98.26 2.1A1.9 1.9 0 0 1 19 21.3zm0-2h14l-6-7.3v-6.7h-2v6.7z" />
  </svg>
)
export default SvgAbTesting
